import { Link } from "react-router-dom";
import Layout from "@/components/feature/Layout";
import PageHeader from "@/components/feature/PageHeader";
import usePageMeta from "@/hooks/usePageMeta";
import { faqs } from "@/mocks/mangaData";

export default function Faq() {
  usePageMeta({
    title: "甜蜜惩罚漫画常见问题 | 更新进度与剧情答疑 - 甜蜜惩罚漫画剧情追踪站",
    description:
      "甜蜜惩罚漫画常见问题解答：更新进度、主线脉络、关键分话、男女主感情线与结局线索等读者高频疑问，一次为你答疑。",
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqs.map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: { "@type": "Answer", text: f.a },
      })),
    },
  });

  return (
    <Layout>
      <PageHeader
        title="常见问题"
        subtitle="关于甜蜜惩罚漫画的更新进度、主线脉络、关键分话与结局线索，这里整理了读者最常问的问题并一一解答。"
        crumbs={[{ label: "首页", path: "/" }, { label: "常见问题" }]}
      />

      <section className="py-12 md:py-16">
        <div className="mx-auto max-w-3xl px-4 md:px-6">
          <div className="flex flex-col gap-3">
            {faqs.map((f, i) => (
              <details
                key={f.q}
                open={i === 0}
                className="group rounded-lg border border-background-200 bg-background-50 px-5 py-4 open:border-primary-300 transition-colors"
              >
                <summary className="flex cursor-pointer items-center justify-between gap-4 list-none">
                  <h2 className="font-medium text-foreground-950">{f.q}</h2>
                  <span className="grid w-8 h-8 shrink-0 place-items-center rounded-full bg-primary-100 text-primary-700 group-open:rotate-45 transition-transform">
                    <i className="ri-add-line text-lg leading-none"></i>
                  </span>
                </summary>
                <p className="mt-3 text-sm md:text-[15px] leading-7 text-foreground-700">{f.a}</p>
              </details>
            ))}
          </div>

          <div className="mt-10 rounded-lg border border-background-200 bg-background-100 p-6 text-center">
            <h2 className="font-heading text-lg font-semibold mb-2">还有疑问？</h2>
            <p className="text-sm text-foreground-700 mb-4">想了解更多剧情主线与结局线索，可以查看本站的角色解析与分话详解。</p>
            <div className="flex flex-col sm:flex-row justify-center gap-3">
              <Link
                to="/characters"
                className="inline-flex items-center justify-center gap-1.5 rounded-full bg-primary-500 text-background-50 px-5 py-2.5 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
              >
                <i className="ri-user-heart-line text-base leading-none"></i>
                角色解析
              </Link>
              <Link
                to="/chapters"
                className="inline-flex items-center justify-center gap-1.5 rounded-full border border-background-300 text-foreground-800 px-5 py-2.5 text-sm font-medium hover:border-primary-400 hover:text-primary-700 transition-colors whitespace-nowrap"
              >
                <i className="ri-book-open-line text-base leading-none"></i>
                分话详解
              </Link>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}